import {
  DocumentationAnalyticsSortInputObject,
  SortDirectionEnum,
} from 'graphql-common';
import {
  ORDERING_DIRECTION_ASC,
  ORDERING_DIRECTION_DESC,
} from '@lib/enums/urls';

const sortableFields = new Set([
  'name',
  'categoryName',
  'viewCount',
  'uniqueViews',
  'avgTime',
  'minTime',
  'maxTime',
]);

export default function getAnalyticsDocumentSorts(
  orderingField?: string | null,
  orderingDirection?: string | null,
): DocumentationAnalyticsSortInputObject | undefined {
  if (!orderingField || !sortableFields.has(orderingField)) return undefined;
  let direction: SortDirectionEnum;
  if (orderingDirection === ORDERING_DIRECTION_ASC) {
    direction = SortDirectionEnum.Asc;
  } else if (orderingDirection === ORDERING_DIRECTION_DESC) {
    direction = SortDirectionEnum.Desc;
  } else {
    return undefined;
  }
  return {
    [orderingField]: direction,
  } as DocumentationAnalyticsSortInputObject;
}
